exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.Vue-NoFeedback[data-v-c222d53c]{margin:20px;cursor:pointer\n}\n", "", {"version":3,"sources":["/var/www/html/limetrial.com/assets/vue-materials/src/NoFeedback/index.vue"],"names":[],"mappings":";AA0CA,iCACE,YACA,cAAe;CAChB","file":"index.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.Vue-NoFeedback {\n  margin: 20px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports
